'use strict';

//Forge Local Storage v0.0.1
//tool for reading/writing window.localStorage

/*
    LocalStorage format:
    {
        "viewName": {  // top level view
            "prop1": ...,
            "prop2": ...
            "viewId" { // subset of view
                "prop1": ...,
                "prop2": ...
            }
        }
    }

    Example:
    {
        "project": {
            "5": {
                "sort": {
                    "type": "SORT_MODIFIED",
                    "asc": false
                }
            }
        },
        "channel": {
            "view_type": "LIST",
            "1": {
                "sort": {
                    "type": "date",
                    "asc": true,
                    "key": "created_at"
                }
            }
        }
    }

*/

module.exports = {
    forgeLsVersion: "0.0.1", //for future format changes/invalidations
    viewSettingKey: "view_settings",

    _storageAvailable: function() {
        try {
            var storage = window['localStorage'];
            var x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);

            storage.setItem('forgeLsVersion', this.forgeLsVersion);
            return true;
        }
        catch(e) {
            console.debug('localStorage unavailable');
            return false;
        }
    },

    setViewSettingPropForViewSubset: function(viewName, viewId, viewProp, props) {
        if (!this._storageAvailable) {
            return;
        }

        let viewSettings = JSON.parse(window.localStorage.getItem(this.viewSettingKey) || '{}');

        if (!viewSettings[viewName]) viewSettings[viewName] = {};
        if (!viewSettings[viewName][viewId]) viewSettings[viewName][viewId] = {};

        viewSettings[viewName][viewId][viewProp] = props; //TODO: merge?

        try {
            localStorage.setItem(this.viewSettingKey, JSON.stringify(viewSettings));
        }
        catch (e) {
            console.warn('localStorage.setViewSettingPropForViewSubset failed');
        }
    },

    getViewSettingPropForViewSubset: function(viewName, viewId, viewProp) {
        if (!this._storageAvailable) {
            return null;
        }

        let viewSettings = JSON.parse(window.localStorage.getItem(this.viewSettingKey) || '{}');
        const exists = viewSettings[viewName] && viewSettings[viewName][viewId] && viewSettings[viewName][viewId][viewProp];

        return exists ? viewSettings[viewName][viewId][viewProp] : null;
    },

    setViewSettingPropForView: function(viewName, viewProp, props) {
        if (!this._storageAvailable) {
            return;
        }

        let viewSettings = JSON.parse(window.localStorage.getItem(this.viewSettingKey) || '{}');

        if (!viewSettings[viewName]) viewSettings[viewName] = {};
        viewSettings[viewName][viewProp] = props; //TODO: merge?

        try {
            localStorage.setItem(this.viewSettingKey, JSON.stringify(viewSettings));
        }
        catch (e) {
            console.warn('localStorage.setViewSettingPropForView failed');
        }
    },

    getViewSettingPropForView: function(viewName, viewProp) {
        if (!this._storageAvailable) {
            return null;
        }

        let viewSettings = JSON.parse(window.localStorage.getItem(this.viewSettingKey) || '{}');
        const exists = viewSettings[viewName] && viewSettings[viewName][viewProp];

        return exists ? viewSettings[viewName][viewProp] : null;
    }
}